import type { AnchorHTMLAttributes, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type ButtonVariant = 'lime' | 'ink' | 'cream' | 'outline-cream' | 'outline-ink'

export const buttonVariants: Record<ButtonVariant, string> = {
    'lime': 'bg-lime text-ink hover:bg-[#e2f86b] focus-visible:outline-lime',
    'ink': 'bg-ink text-cream hover:bg-court-deep focus-visible:outline-ink',
    'cream': 'bg-cream text-ink hover:bg-white focus-visible:outline-cream',
    'outline-cream': 'border border-cream/45 text-cream hover:border-cream hover:bg-cream/10 focus-visible:outline-cream',
    'outline-ink': 'border border-ink/30 text-ink hover:border-ink hover:bg-ink/5 focus-visible:outline-ink'
}

export const buttonBase = 'inline-flex min-h-11 items-center justify-center gap-2 rounded-full px-6 text-sm font-semibold tracking-[0.01em] transition-colors duration-200 focus-visible:outline-2 focus-visible:outline-offset-4 disabled:cursor-not-allowed disabled:opacity-60'

interface ButtonLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    variant?: ButtonVariant
    children: ReactNode
}

export const ButtonLink: FC<ButtonLinkProps> = ({ variant = 'lime', className, children, ...props }): ReactNode => {
    return (
        <a className={cn(buttonBase, buttonVariants[variant], className)} {...props}>
            {children}
        </a>
    )
}
